import { z } from 'zod';
/**
 * Gemeldet wird nur, **dass** sich an einer Firma etwas geändert hat. Was,
 * lesen wir selbst — ein Rumpf mit Werten wäre ein zweiter Schreibweg ins
 * Konto, an dem niemandes Berechtigung hängt (LIC-29).
 */ export const CrmCompanyChangedRequestSchema = z.object({
    companyId: z.string().trim().min(1)
});
export const CrmCompanyChangedResponseSchema = z.object({
    /** Wie viele Konten dadurch einen neuen Stand bekommen haben. */ reconciled: z.number().int().nonnegative()
});
/**
 * CRM Company Changed Endpoint Contract
 *
 * Der Weg, der ohne Operations Hub auskommt: n8n beobachtet die
 * Firmen-Properties und ruft uns je geänderter Firma. Gedrosselt, weil jeder
 * Aufruf eine HubSpot-Abfrage auslöst.
 */ export const crmCompanyChangedContract = {
    method: 'POST',
    path: '/api/v2/integrations/crm/company-changed',
    description: 'Tell Bliks a HubSpot company changed, so it re-reads it',
    requestSchema: CrmCompanyChangedRequestSchema,
    responseSchema: CrmCompanyChangedResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            401: 'Unauthorized - shared secret missing or wrong',
            429: 'Too Many Requests'
        }
    }
};

//# sourceMappingURL=index.js.map